import styled from "@emotion/styled";
import { throttle } from "lodash";
import * as React from "react";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { DropdownContent, DropdownShadow } from "components/dropdown/DropdownContent";
import { StackingContextLevel } from "styles/stacking-context-level";

export enum DropdownDirection {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
}

export enum DropdownPlacement {
  Center = "center",
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
}

interface IProps {
  directions?: DropdownDirection[];
  placement?: DropdownPlacement;
  offset?: number;
  shadow?: DropdownShadow;
  isVisible: boolean;
  children: React.ReactNode;
  content: React.ReactChild;
  chevronPosition?: string;
  onHideDropdown(): void;
  triggerRef?(event: HTMLElement): void;
}

interface IState {
  direction: DropdownDirection;
  placement: DropdownPlacement;
  offset: number;
  xPosition: number;
  yPosition: number;
}

const StyledDropdown = styled.div`
  position: relative;
  z-index: ${StackingContextLevel.Preview};
`;

/* eslint-disable no-underscore-dangle, react/sort-comp, no-array-constructor, react/jsx-no-bind, prefer-destructuring */
export class Dropdown extends React.Component<IProps, IState> {
  // @ts-expect-error TS(2564): Property '_dropdownRef' has no initializer and is ... Remove this comment to see the full error message
  private _dropdownRef: HTMLDivElement;
  // @ts-expect-error TS(2564): Property '_dropdownContentRef' has no initializer ... Remove this comment to see the full error message
  private _dropdownContentRef: HTMLDivElement;
  // @ts-expect-error TS(2564): Property '_triggerRef' has no initializer and is n... Remove this comment to see the full error message
  private _triggerRef: HTMLElement;
  // @ts-expect-error TS(2564): Property '_lastDropdownRefTop' has no initializer ... Remove this comment to see the full error message
  private _lastDropdownRefTop: number;
  // @ts-expect-error TS(2564): Property '_lastDropdownRefLeft' has no initializer... Remove this comment to see the full error message
  private _lastDropdownRefLeft: number;
  private _resizeHandler: EventListener;
  // @ts-expect-error TS(2564): Property '_warnDisplayed' has no initializer and i... Remove this comment to see the full error message
  private _warnDisplayed: boolean;

  constructor(props: IProps) {
    super(props);

    this.state = {
      direction: props.directions && props.directions.length ? props.directions[0] : DropdownDirection.Top,
      placement: props.placement || DropdownPlacement.Center,
      offset: props.offset ? props.offset : 0,
      xPosition: 0,
      yPosition: 0,
    };

    this._onDropdownRef = this._onDropdownRef.bind(this);
    this._onDropdownContentRef = this._onDropdownContentRef.bind(this);
    this._calculatePosition = this._calculatePosition.bind(this);
    this._checkRecalculatePosition = this._checkRecalculatePosition.bind(this);
    this._onWindowResize = this._onWindowResize.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);
    this._resizeHandler = throttle(() => this._onWindowResize(), 50);
  }

  componentWillUnmount(): void {
    this._removeEventHandlers();
  }

  componentDidUpdate(prevProps: IProps): void {
    const { isVisible } = this.props;

    // Dropdown is shown
    if (isVisible && !prevProps.isVisible) {
      this._addEventHandlers();
    }

    // Recalculate position only of dropdown is visible
    if (isVisible) {
      this._checkRecalculatePosition();
    }

    // Dropdown is hidden, stop listen global events
    if (!isVisible && prevProps.isVisible) {
      this._removeEventHandlers();
    }
  }

  private _addEventHandlers(): void {
    window.addEventListener("resize", this._resizeHandler);
    document.addEventListener("click", this._onDocumentClick);
  }

  private _removeEventHandlers(): void {
    window.removeEventListener("resize", this._resizeHandler);
    document.removeEventListener("click", this._onDocumentClick);
  }

  private _onWindowResize(): void {
    this._checkRecalculatePosition();
  }

  private _onDocumentClick(event: Event): void {
    const { onHideDropdown } = this.props;
    if (
      this._dropdownRef &&
      !this._dropdownRef.contains(event.target as Node) &&
      (!this._triggerRef || (this._triggerRef && !this._triggerRef.contains(event.target as Node)))
    ) {
      onHideDropdown();
    }
  }

  private _onDropdownRef(el: HTMLDivElement): void {
    this._dropdownRef = el;
  }

  private _onDropdownContentRef(el: HTMLDivElement): void {
    this._dropdownContentRef = el;
  }

  private _checkRecalculatePosition(): void {
    const dropdownRefRect: ClientRect = this._dropdownRef.getBoundingClientRect();
    if (dropdownRefRect.top !== this._lastDropdownRefTop || dropdownRefRect.left !== this._lastDropdownRefLeft) {
      this._recalculatePosition();
    }
  }

  private _recalculatePosition(): void {
    const directionsChecked: DropdownDirection[] = [];
    let dropdownDirection = this._dropdownDirection(directionsChecked);

    while (!this._calculatePosition(dropdownDirection)) {
      directionsChecked.push(dropdownDirection);
      dropdownDirection = this._dropdownDirection(directionsChecked);
    }
  }

  private _calculatePosition(direction: DropdownDirection): boolean {
    const placement = this._dropdownPlacement(direction);
    const dropdownRefRect: ClientRect = this._dropdownRef.getBoundingClientRect();
    const dropdownContentRefRect: ClientRect = this._dropdownContentRef.getBoundingClientRect();
    let dropdownXPosition;
    let dropdownYPosition;

    this._lastDropdownRefTop = dropdownRefRect.top;
    this._lastDropdownRefLeft = dropdownRefRect.left;

    switch (direction) {
      case DropdownDirection.Top:
        dropdownYPosition = dropdownRefRect.top - dropdownContentRefRect.height - this.state.offset;

        if (placement === DropdownPlacement.Center) {
          dropdownXPosition = dropdownRefRect.left + (dropdownRefRect.width / 2 - dropdownContentRefRect.width / 2);
        } else if (placement === DropdownPlacement.Left) {
          dropdownXPosition = dropdownRefRect.left - 7;
        } else if (placement === DropdownPlacement.Right) {
          dropdownXPosition = dropdownRefRect.left + dropdownRefRect.width / 2 + 23 - dropdownContentRefRect.width;
        }
        break;

      case DropdownDirection.Bottom:
        dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height + this.state.offset;

        if (placement === DropdownPlacement.Center) {
          dropdownXPosition = dropdownRefRect.left + (dropdownRefRect.width / 2 - dropdownContentRefRect.width / 2);
        } else if (placement === DropdownPlacement.Left) {
          dropdownXPosition = dropdownRefRect.left - 7;
        } else if (placement === DropdownPlacement.Right) {
          dropdownXPosition = dropdownRefRect.left + dropdownRefRect.width / 2 + 23 - dropdownContentRefRect.width;
        }
        break;

      case DropdownDirection.Right:
        dropdownXPosition = dropdownRefRect.left + dropdownRefRect.width + this.state.offset;

        if (placement === DropdownPlacement.Center) {
          dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height / 2 - dropdownContentRefRect.height / 2;
        } else if (placement === DropdownPlacement.Top) {
          dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height / 2 - 23;
        } else if (placement === DropdownPlacement.Bottom) {
          dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height / 2 + 23 - dropdownContentRefRect.height;
        }
        break;

      case DropdownDirection.Left:
        dropdownXPosition = dropdownRefRect.left - dropdownContentRefRect.width - this.state.offset;

        if (placement === DropdownPlacement.Center) {
          dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height / 2 - dropdownContentRefRect.height / 2;
        } else if (placement === DropdownPlacement.Top) {
          dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height / 2 - 23;
        } else if (placement === DropdownPlacement.Bottom) {
          dropdownYPosition = dropdownRefRect.top + dropdownRefRect.height / 2 + 23 - dropdownContentRefRect.height;
        }
        break;

      default:
        dropdownXPosition = 0;
        dropdownYPosition = 0;
        break;
    }

    // @ts-expect-error TS(2322): Type 'number | undefined' is not assignable to typ... Remove this comment to see the full error message
    this.setState({ placement, xPosition: dropdownXPosition, yPosition: dropdownYPosition });

    return true;
  }

  private _dropdownDirection(directionsChecked: DropdownDirection[]): DropdownDirection {
    const defaultQueue: DropdownDirection[] = [
      DropdownDirection.Top,
      DropdownDirection.Bottom,
      DropdownDirection.Left,
      DropdownDirection.Right,
    ];
    const { directions } = this.props;

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const propsDirection: DropdownDirection = directions.filter(
      (direction: DropdownDirection) => directionsChecked.indexOf(direction) === -1
    )[0];

    const defaultDirection: DropdownDirection = defaultQueue.filter(
      (direction: DropdownDirection) => directionsChecked.indexOf(direction) === -1
    )[0];

    if (propsDirection) {
      return propsDirection;
    }

    if (defaultDirection) {
      return defaultDirection;
    }

    return DropdownDirection.Top;
  }

  private _dropdownPlacement(direction: DropdownDirection): DropdownPlacement {
    const availablePlacement = {
      [DropdownDirection.Top]: [DropdownPlacement.Left, DropdownPlacement.Right, DropdownPlacement.Center],
      [DropdownDirection.Bottom]: [DropdownPlacement.Left, DropdownPlacement.Right, DropdownPlacement.Center],
      [DropdownDirection.Left]: [DropdownPlacement.Top, DropdownPlacement.Bottom, DropdownPlacement.Center],
      [DropdownDirection.Right]: [DropdownPlacement.Top, DropdownPlacement.Bottom, DropdownPlacement.Center],
    };

    let placement = this.props.placement;

    // @ts-expect-error TS(2345): Argument of type 'DropdownPlacement | undefined' i... Remove this comment to see the full error message
    if (availablePlacement[direction].indexOf(placement) === -1) {
      placement = DropdownPlacement.Center;

      if (!this._warnDisplayed) {
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line no-console
        console.warn(
          `[Dropdown] Current dropdown placement is not supported for the direction, using default instead: ${DropdownPlacement.Center}`
        );
        this._warnDisplayed = true;
      }
    }

    // @ts-expect-error TS(2322): Type 'DropdownPlacement | undefined' is not assign... Remove this comment to see the full error message
    return placement;
  }

  render(): JSX.Element {
    const { children, isVisible, shadow, chevronPosition } = this.props;
    const { direction, placement, xPosition, yPosition } = this.state;
    return (
      <StyledDropdown ref={this._onDropdownRef.bind(this)}>
        {children}

        <DropdownContent
          contentRef={this._onDropdownContentRef}
          direction={direction}
          placement={placement}
          shadow={shadow}
          isVisible={isVisible}
          xPosition={xPosition}
          yPosition={yPosition}
          chevronPosition={chevronPosition}
        >
          {this.props.content}
        </DropdownContent>
      </StyledDropdown>
    );
  }
}
